var Payment = xClass("HonorQuickgamePayment")
Payment.prototype.ctor = function () {

}

// 获取失败类型
Payment.prototype.getFailType = function (errCode) {
    let fail_type = 1;
    if (errCode == 301004){
        fail_type = -1;
    }
    return fail_type;
}

Payment.prototype.buy = function (data, successCallback, failCallback, closeCallback) {
    let self = this

    console.warn("[####]call honor pay id:"+data.productId)
    let productId = data.productId
    //productId = "com.happyelements.newshop.gold.1"

    function onSuccess(resp) {
        let data = resp.data
        console.log("[################]getinfohttp success")
        let orderId = data.orderId;
        let balance = data.balance
        let cash = data.cash
        //data.paySign//后端生成的签名的时间戳
        console.log("[#############]honor pay data "+ JSON.stringify(data))
        if (!balance || balance < cash) {
            console.log("[################]call honor pay")
            // 余额不足，充值
            let payment = {
                productInfo:{
                    appId:"300109637",
                    cpId:"109999790720",
                    productId:productId,
                    publicKey:"MIIBojANBgkqhkiG9w0BAQEFAAOCAY8AMIIBigKCAYEAg/piWyZ/Zt65Wg/2WdFcRbHmBtzzY44iSeGPVfmnsx4Yv0WFKXe0ZlONIyDhMqeoqTRR3fyAWUTpz4JHCQi8XuaIe245ZflS90Vbsuv6Hdgmw/BLnfIJVk04ZMrqP5oiNMM2sX2PE/m4lj0wPLGqSKRSwHQFtZXm/asNQ3d+TV8Wo4NlNxNfl51mL5gBiTRiGYdoE2Yp9Su/4DdagWosCX+Fm4plWW/sa3YqB+soSvbilzCqFALyv65MFLEAOdxHubfx+PIk3W03lP0VrhbEwQSSRK6zoLyzr4a6IringyTcfMG/pPwobDKIkko41Zdp3ZCckz6sC9PGDdcMsqwKyiMyahAO8J2BG/X7TgT/6bIMzFSlAXVh/stZKsoAD004Lvs1968itgt63UxwVNkKQ2p5v5dK+b4s+s02tbXXezDyAerPQZ5jaBn5mJYO4TPjAfeuKaCzfJdSv0qhXwP/RVrP8/e0SDcP+PD+iQJsrKtQXMy86kTSpuZZSfkBbMhtAgMBAAE=",
                    productName:"",
                    productDesc:"",
                    orderAmount:data.price*100,
                    developerPayload:data.orderId
                },
                success: function(res) {
                    console.log("[######]pay success res:"+JSON.stringify(res))
                    successCallback && successCallback({orderId});
                },
                cancel: function() {
                    console.log("[######]pay cancel")
                },
                complete: function() {
                    console.log("[######]pay complete")
                },
                fail: function (res) {
                    console.log("[######]pay fail res:"+JSON.stringify(res))
                    let fail_type = self.getFailType(res.errCode);
                    failCallback({
                        code: res.errCode,
                        data: res.data,
                        msg: res.errMsg,
                        type: fail_type,//1代表是第三方掉起支付失败
                    })
                }
            }
            mini.pay(payment)
        } 
        else 
        {
            // 余额够，不需要充值，直接购买
            //pay()
        }
    }

    function onFail(evt) {
        cc.log("[#####]getinfohttp failed" + evt.data)
        let errcode = evt ? evt.data : -1;
        failCallback({
            code: errcode,
            data: "初始化订单失败"
        })
    }

    function onCancel() {
        console.log("[####]getinfohttp canecel")
        failCallback({
            code: -1,
            data: "初始化订单取消"
        })
    }

    let http = HonorQuickgamePaymentGetInfoHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load({
        productId:productId,
        openid: META.tokenid,
        zoneId: META.user.serverid,
        sessionid: META.user.sessionid,
        engineVersion:META.platformVersion,
        ext: data.ext
    })
}

module.exports = Payment